export default {
  Supply: 'rgb(207, 223, 255)',
  'Manufacturing and Production': 'rgb(208, 240, 253)',
  Price: 'rgb(194, 245, 233)',
  Funding: 'rgb(209, 247, 196)',
  'Vaccine approvals/rejections': 'rgb(207, 223, 255)',
  'Treatment approvals/rejections': 'rgb(207, 223, 255)',
}
